import { useDispatch, useSelector } from 'react-redux';
import { useRunOnceEffect } from './useRunOnceEffect';
import { listAllAutocompleteProperties } from 'store/slices/properties';

export const useAutocompleteProperties = () => {
  const dispatch = useDispatch();

  useRunOnceEffect(() => {
    dispatch(listAllAutocompleteProperties());
  });

  const loading = useSelector((state) => state.properties.autocompleteProperties?.loading || false);
  const allProperties = useSelector((state) => state.properties.autocompleteProperties?.value || []);
  const offset = useSelector((state) => state.properties.autocompleteProperties?.offset);
  const hasMore = useSelector((state) => state.properties.autocompleteProperties?.hasMore);

  return {
    loading,
    allProperties,
    offset,
    hasMore,
  };
};
